.Toaster {
  position: relative;

  display: flex;
  align-items: center;

  &_Body {
    flex: 1 1;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: normal;

    &_Message {
      margin-bottom: 2rem;
    }
  }
}
